export const dpFaqs = [
  {
    question: "What exactly are we monetizing?",
    answer:
      "Your existing business workflows. The work your teams already do becomes training and verification data for the companies building and evaluating AI. No one learns a new job; they do their normal work, and it becomes something the market pays for.",
  },
  {
    question: "Will this disrupt our team's day-to-day?",
    answer:
      "No. There are no systems to integrate and no bulk data to hand over. Your teams work exactly as they do today, within a scope you approve, and you decide how much of their time is available. You can pause or adjust scope at any point.",
  },
  {
    question: "How do we get paid, and how much?",
    answer:
      "You are paid per verified completion, monthly, in USD. What you earn scales with the volume, type, and rarity of the work your teams contribute. There is no fixed ceiling: the more valuable and specialized the work, the more it pays.",
  },
  {
    question: "Who decides what our people earn?",
    answer:
      "You do. We pay your business per verified completion, and you set how much of that flows to the people doing the work and how much the business keeps as margin. It is a new revenue line on hours you are already paying for.",
  },
  {
    question: "What about confidential or sensitive information?",
    answer:
      "Your company stays in control of scope. Before anyone participates, we define approved workflows and clear boundaries, anonymization and redaction requirements, security and confidentiality terms, and your own internal approvals. We do not ask for unrestricted access to your systems or sensitive internal data.",
  },
  {
    question: "What kinds of work qualify?",
    answer:
      "Most knowledge and operational work fits: software and engineering, finance and accounting, customer support, sales and CRM, legal and contracts, and egocentric video of how your teams work, among others. If your team does it every day and it takes real expertise, it is likely valuable. A short call is the fastest way to confirm.",
  },
  {
    question: "Is this a one-time data sale?",
    answer:
      "No. This is a recurring, long-term partnership. Your teams contribute over time, and payouts recur every month as they do. The deepest partnerships grow into a meaningful, ongoing revenue line rather than a single transaction.",
  },
  {
    question: "How do we get started?",
    answer:
      "Book a short call with our partnerships team. We scope the workflows that fit and agree on privacy and boundaries. From there, we handle verification and payouts.",
  },
];
